import $ from 'jquery';
import ScrollMagic from "ScrollMagic";
import 'debug.addIndicators';
import 'animation.gsap';
import { Power1, Power0, Power4, Linear, TweenMax } from "gsap/TweenMax";

export default () => {
    let controller = new ScrollMagic.Controller();

    let section = $('.animate');
    section.each((i, el) => {

        new ScrollMagic.Scene({
            triggerElement: el,
            triggerHook: 0.75,
            reverse: false
        })
            .addTo(controller)
            //.addIndicators({name: `Animage ${i} Testi`})
            .on("enter", (e) => {
                let element = $(e.target.triggerElement());

                // tags.each((i, el) => {

                let velocity = 1;

                TweenMax.fromTo(element, velocity, { y: '30px', autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Power4.easeOut });
                // });
            });
    });

};



// WEBPACK FOOTER //
// ./scripts/libs/animazione-testi.js